import { ENTITY_DETAIL_ROUTES } from '../../shared/header/shared-header.component';
import { CalendarEventDto } from '../../models/calendar.models';

/** Same shape as AuthService.hasRole, so a spec can pass a plain function. */
export type HasRole = (role: string) => boolean;

/**
 * Roles that may open the Calendar: the single list behind both the route guard (route `data.roles`) and, by value, the
 * Calendar nav item. Which types a role sees is not decided here - the backend returns `allowedTypes`.
 */
export const CALENDAR_ROLES: readonly string[] = [
  'FacilityManager',
  'AssetManager',
  'StoreInventoryManager',
  'MaintenanceTechnician',
  'VendorContractor',
  'SystemAdmin',
];

/** Roles the backend lets use scope=All; everyone else is served Mine whatever they ask. */
export function canUseAllScope(has: HasRole): boolean {
  return has('FacilityManager') || has('AssetManager') || has('StoreInventoryManager') || has('SystemAdmin');
}

/**
 * The router commands of the record an event points at, or null when this user cannot open it (the drawer then shows
 * the summary only - access is never widened, design §10.9). The approvals event opens My approvals; a purchase
 * order opens only for store managers and facility managers, an asset only for asset managers and facility managers.
 */
export function openRouteFor(has: HasRole, event: CalendarEventDto): string[] | null {
  const segment = ENTITY_DETAIL_ROUTES[event.entityType];
  if (!segment) return null;
  if (event.entityType === 'WorkflowTask') return ['/', segment];
  if (!event.entityId) return null;
  if (event.entityType === 'PurchaseOrder' && !(has('StoreInventoryManager') || has('FacilityManager'))) return null;
  if (event.entityType === 'Asset' && !(has('AssetManager') || has('FacilityManager'))) return null;
  return ['/', segment, event.entityId];
}
